import React, { useState, useEffect } from "react"
import Block from "@bappweb/block"
import Image from "@bappweb/image"
import Element from "@bappweb/element"
import Link from "@bappweb/link"
import { useGetConfigMutation } from "../../../api/service"
import "../assets/style.scss"

const LandingHeader = () => {
  const [campaignTextTop, setCampaignTextTop] = useState('')
  const [campaignTextBottom, setCampaignTextBottom] = useState('')

  const [getConfig] = useGetConfigMutation();
  useEffect(() => {
    getConfig("MobilUygulamaIndir.CampaignText.Landing.Top")
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setCampaignTextTop(payload.configValue)
        }
      })

    getConfig("MobilUygulamaIndir.CampaignText.Landing.Bottom")
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setCampaignTextBottom(payload.configValue)
        }
      })
  }, [getConfig])

  return (
    <Block type="header" className="download-app-header">
      <Block className="container">
        <Block className="caption">
          <Link>
            <Image
              path={"./img/mobiluygulama/logo-akbank.png"}
              className="landing-header-logo-img"
            />
          </Link>
          <Element type="h3">
            <Block dangerouslySetInnerHTML={{ __html: campaignTextTop }} />
          </Element>
          <Element>
            <Block dangerouslySetInnerHTML={{ __html: campaignTextBottom }} />
          </Element>
        </Block>
        <Block className="picture">
          <Image
            path={"./img/mobiluygulama/header-img.png"}
            className="landing-header-img"
          />
        </Block>
      </Block>
    </Block>
  )
}

export default LandingHeader
